const SessionAvailability = require('@/lib/Sessions/SessionAvailability');

class SessionAvailabilityService {
    /**
     * @param {ApiClient} apiClient
     * @param {UserService} userService
     */
    constructor(
        apiClient,
        userService
    ) {
        this.apiClient = apiClient;
        this.userService = userService;
    }

    /**
     * @param {Session[]} sessions
     * @param {{qty: number, itemID: number}[]} [requestedTickets]
     * @param {number|null} [originalOrderID]
     *
     * @return {Promise<Object.<number, SessionAvailability>>}
     */
    loadSessionAvailabilities(
        sessions,
        requestedTickets = null,
        originalOrderID = null
    ) {
        const sessionIDs = sessions.map((s) => s.ID);

        const requestData = {
            resolve: 'spaces',
            sessionIDs: sessionIDs.join(','),
        };

        if (requestedTickets !== null) {
            requestData.lines = requestedTickets;
        }

        if (originalOrderID) {
            requestData.originalOrderID = originalOrderID;
        }

        const endpoint = 'sessionavailability?'
            + new URLSearchParams({
                // Set the branchID to the item branch ID.
                branchID: this.userService.getItemBranchID(),
            }).toString();

        return this.apiClient
            .request(
                'POST',
                endpoint,
                requestData
            )
            .then((response) => {
                const availabilities = {};

                Object.values(response.data).forEach((val) => {
                    const spacesSold = parseInt(val.spaces.spacesSold, 10);
                    const spacesReserved = parseInt(val.spaces.spacesReserved, 10);
                    const availability = new SessionAvailability(
                        val.sessionID,
                        parseInt(val.spaces.spacesAvailable, 10),
                        spacesSold,
                        spacesReserved
                    );

                    // Add Bookable Resource availability.
                    if (val.hasOwnProperty('available')) {
                        availability.bookableResourcesAvailable = val.available;
                    }
                    if (val.hasOwnProperty('suitable')) {
                        availability.bookableResourcesSuitable = val.suitable;
                    }

                    if (val.hasOwnProperty('groupBookingCount')) {
                        availability.groupBookingCount = parseInt(val.groupBookingCount, 10);
                    }

                    availabilities[availability.sessionID] = availability;
                });

                return availabilities;
            });
    }
}

module.exports = SessionAvailabilityService;
